import type { UserHydraItem } from '@composables/user/user.interface'
import type { AuthResponseV2, LoginRequestInterface, RefreshRequestInterface } from '@core/api/Interface'
import type { AxiosRequestConfig } from 'axios'

export async function onAuthenticateSuccess(response: AuthResponseV2, input: LoginRequestInterface | RefreshRequestInterface): Promise<void> {
  const { fetchShops } = useShops()
  const { login, setUser } = useAuthStore()
  login(response, input)

  const user = await api.get<UserHydraItem>('/api/users/me', {
    _retry: false,
  } satisfies AxiosRequestConfig & { _retry: boolean } as any)
    .then(r => r.data)
  setUser(user)
  await fetchShops()
}
